import { createSelector } from 'reselect';
import { IAppState } from '../../../AppModulesWrapper';
import { selectActiveService } from '../publishTerms';
import { IPromotionService } from '../../reducers/v2';

export interface IDiffPricingIds {
  diffPriceId: number;
  diffPriceIterationId: string;
  diffPriceGranuleGuid: string;
}

export const selectAnalyticsDiffPricingIds = createSelector(
  [(state: IAppState) => selectActiveService(state)],
  (activeService: IPromotionService): IDiffPricingIds | null => {
    if (!activeService) {
      return null;
    }

    const { diffPriceId, diffPriceIterationId, diffPriceGranuleGuid } = activeService;

    const isSomeParamsPresent = [diffPriceId, diffPriceIterationId, diffPriceGranuleGuid].some(Boolean);

    if (isSomeParamsPresent) {
      return {
        diffPriceId,
        diffPriceIterationId,
        diffPriceGranuleGuid,
      };
    }

    return null;
  },
);
